# Theme variables injected by gulp
THEME_NAME = 'bogen'
angular.module('app.controllers').controller 'FavsCtrl', [
  '$scope', '$rootScope', 'Table', 'APIFavoritesTable', 'APIFavorites'
].append (self, root, Table, APIFavoritesTable, APIFavorites) ->
    

  tableName   = 'c.fav.' + (root.user?.shortcode || 'test')
  cookiesName = 't.' + tableName

  self.gridMode = true

  self.types = [
    {
      type: 'e'
      title: 'Aussteller'
      link: 'aussteller'
    }
    {
      type: 's'
      title: 'Programm'
      link: 'programm'
    }
    {
      type: 'n'
      title: 'Neuheiten'
      link: 'neuheiten'
    }
  ]

  self.typeIndex = 0

  self.setType = (typeIndex) ->
    self.typeIndex = typeIndex
    self.favs.params.entry_type = self.types[typeIndex].type
    self.page = 1  # Reset page counter when switching between favorite types


  self.favs = Table
    name: tableName
    type: "partial"
    resource: APIFavoritesTable
    cookies: false
    params: 
      limit: 12
      orderby: "title"
      entry_type: "e"
      favs: true
      shortcode: root.user?.shortcode || root.tuser || 'default'

  self.page = 1
  self.loadMore = () ->
    return if self.page >= self.favs.data.pages
    
    self.page++ 
    
    params = angular.copy(self.favs.params)
    params.page = self.page

    self.moreLoad = true
    APIFavorites.query params, (data) ->
      self.more = data
      self.favs.data.display = self.favs.data.display.concat(self.more)
      self.moreLoad = false


  root.$on 'forceFavs', (event) ->
    return self.favs.reload()

  tabEls = document.querySelectorAll('button[data-bs-toggle="tab"]')
  tabEls.forEach (tabEl, ind) ->
    tabEl.addEventListener 'shown.bs.tab', (event) ->
      self.setType(ind)
      self.$applyAsync()